/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Modal, Table, Button, Spin } from 'antd'
import { SelectOutlined } from '@ant-design/icons'
import { useSelector, useDispatch } from 'react-redux'

import { onListSupplierByName } from 'redux/actions'

import InlineInput from 'components/InlineInput'

const SearchSupplierVatPopUp = ({ visible, onClick, onCancel }) => {
  const [list, setList] = useState([])
  const [name, setName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [filteredList, setFilteredList] = useState([])
  const dispatch = useDispatch()
  let listSupplierByName = useSelector(
    (state) => state.listSupplierByName
  )

  useEffect(() => {
    const { error, loading, finished, data, trace } = listSupplierByName
    if (!error && !loading && finished) {
      setList(data)
      setFilteredList(data)
      setIsLoading(false)
    }
    if (error && !loading) {
      Modal.error({
        centered: true,
        title: 'ตรวจสอบ',
        content: `${trace.message}`,
      })
      setIsLoading(false)
    }
  }, [listSupplierByName])

  const handleSearch = (searchValue) => {
    const _list = [...list]
    const filteredData = _list.filter(({ code, name }) => {
      code = code.toString().toLowerCase()
      name = name.toString().toLowerCase()
      return (
        code.includes(searchValue.toLowerCase()) ||
        name.includes(searchValue.toLowerCase())
      )
    })
    setFilteredList(filteredData)
  }

  const fetchList = (value) => {
    setIsLoading(true)
    dispatch(onListSupplierByName(value))
  }

  const onClosePopUp = () => {
    clearInput()
    onCancel()
  }

  const onSelectItem = (record) => {
    onClick(record)
    clearInput()
  }

  const clearInput = () => {
    setList([])
    setFilteredList([])
    setSearchText('')
    setName('')
  }

  const tableColumns = [
    {
      title: '',
      dataIndex: '',
      key: 'x',
      width: '30px',
      render: (_, record) => {
        return (
          <Button
            size="small"
            type="primary"
            icon={<SelectOutlined />}
            onClick={() => onSelectItem(record)}
          />
        )
      },
    },
    {
      title: 'รหัส',
      dataIndex: 'code',
      key: 'code',
      width: '80px',
    },
    {
      title: 'ชื่อ',
      dataIndex: 'name',
      key: 'name',
      width: '400px',
      render: (text) => <div className="break-word">{text}</div>,
    },
  ]

  return (
    <Modal
      visible={visible}
      width="650px"
      onCancel={onClosePopUp}
      footer={null}
      title={
        <div>
          <InlineInput
            onSearch={(value) => {
              fetchList(value)
            }}
            inputOption="search"
            label="ค้นหา"
            placeholder="ใส่ชื่อผู้ขาย"
            value={name}
            width="280px"
            onChange={(event) => {
              setName(event.target.value.toUpperCase())
            }}
          />
        </div>
      }
    >
      <Spin spinning={isLoading}>
        <Table
          rowKey={(record) => `id+${record.code}`}
          dataSource={filteredList}
          columns={tableColumns}
          style={{ height: '420px' }}
          size="small"
          pagination={{
            position: ['bottomRight'],
            simple: true,
            defaultPageSize: 10,
          }}
        />
        <div style={{ position: 'absolute', bottom: '-8px' }}>
          <div className="mb-1">
            <InlineInput
              onSearch={(value) => {
                handleSearch(value)
              }}
              inputOption="search"
              label="กรองข้อมูล"
              placeholder="ใส่รหัส หรือ ชื่อ"
              value={searchText}
              width="280px"
              onChange={(event) => {
                setSearchText(event.target.value.toUpperCase())
              }}
            />
          </div>
        </div>
      </Spin>
    </Modal>
  )
}

export default SearchSupplierVatPopUp
